import { RefObject, useCallback, useEffect } from 'react';

// Select options are rendered outside of the parent component, so we need
// to ignore applying the action if the user clicks on one of the options.
const isPartOfSelectPopper = (element: HTMLElement) => {
  if (!element) {
    return false;
  }
  const selectListboxClass = 'MuiSelect-listbox';

  return element.closest(`.${selectListboxClass}`) !== null;
};

export const useClickOutside = (ref: RefObject<HTMLElement>, action: () => void) => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (ref.current && !ref.current.contains(target) && !isPartOfSelectPopper(target)) {
        action();
      }
    },
    [action, ref]
  );

  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);

    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, [handleClickOutside]);

  return handleClickOutside;
};
